export const HEADER_MAP = activePlanName => ({
  ActivePlan: activePlanName,
  AsSoonAsPossible: 'As Soon as Possible',
  AtAge70: 'At Age 70',
  AtRetirement: 'At Retirement',
  AtFra: 'At FRA',
});
